// extracted by mini-css-extract-plugin
module.exports = {"charts-container":"_1pkG-RdAdduxsfUn9FzDCz","title":"_18xmeHiyi8EpVIag0MXEsk"};